import styles from './Lang.module.scss';

export const Lang = () => {
    return (
        <div className={styles.lang}>EN <span>|</span> <a href="https://dazzz.studio/ru/" target="_blank" rel="nofollow noreferrer">RU</a></div>
    )
}